<template>
  <draggable
    v-model="sortableItems"
    :animation="150"
    :force-fallback="true"
    :scroll-sensitivity="150"
    :scroll-speed="30"
    group="item"
    handle=".p-sortingItem__handle"
    ghost-class="p-sortingItem__ghost"
    @choose="onChoose"
    @clone="onChange"
    @end="onUpdate"
    @unchoose="onUnchoose"
  >
    <div v-for="(item, index) in sortableItems" :key="item.uuid">
      <div :class="{ 'p-sortingItem__active': onChooseItem(item.uuid) }">
        <sorting-item-layout
          v-if="!inCombinedSortTarget(index)"
          :index="index"
          :combined="!!combinedSortTargetIndexes.length"
          @select-item="() => bulkAddCombinedSortTarget(index)"
        >
          <item-preview :item="item" />
        </sorting-item-layout>

        <CombinedSortItems
          v-else-if="combinedSortTargetIndexes[0] === index"
          :items="
            combinedSortTargetIndexes.map(
              (targetIndex) => sortableItems[targetIndex]
            )
          "
          @combined-cancel="resetCombined"
        />
      </div>
    </div>
    <SortingMouseStoker v-if="!!chooseItemId" :item-count="movingItemCount()" />
  </draggable>
</template>

<script>
import draggable from 'vuedraggable'
import _ from 'lodash'
import ItemPreview from '../ItemPreview'
import SortingItemLayout from './SortingItemLayout'
import CombinedSortItems from './CombinedSortItems'
import SortingMouseStoker from './SortingMouseStoker'

export default {
  name: 'SortingItemContainer',
  components: {
    SortingMouseStoker,
    CombinedSortItems,
    SortingItemLayout,
    draggable,
    ItemPreview
  },
  data () {
    return {
      combinedSortTargetIndexes: [],
      beforeMoveSortableItems: [],
      chooseItemId: null
    }
  },
  computed: {
    sortableItems: {
      get () {
        return this.$store.state.PostEditor.post.items
      },
      set (items) {
        this.$store.commit('PostEditor/SORT_ITEMS', items)
      }
    }
  },
  methods: {
    onChoose ({ oldIndex }) {
      if (this.inCombinedSortTarget(oldIndex)) {
        this.beforeMoveSortableItems = [...this.sortableItems]
      }
    },
    onChange ({ oldIndex }) {
      if (!this.inCombinedSortTarget(oldIndex)) {
        this.resetCombined()
      }

      this.chooseItemId = this.sortableItems[oldIndex].uuid
    },
    onUpdate (event) {
      const { oldIndex, newIndex } = event
      if (this.inCombinedSortTarget(oldIndex)) {
        const clonedSortableItems = this.beforeMoveSortableItems.map(
          (item, index) => {
            if (this.inCombinedSortTarget(index)) return undefined
            return { ...item }
          }
        )

        const combinedItems = this.combinedSortTargetIndexes.map(
          (index) => this.beforeMoveSortableItems[index]
        )
        const beforeItems =
          newIndex > oldIndex
            ? clonedSortableItems.splice(0, newIndex + 1)
            : clonedSortableItems.splice(0, newIndex)
        const afterItems = clonedSortableItems

        this.sortableItems = [
          ...beforeItems,
          ...combinedItems,
          ...afterItems
        ].filter((item) => !!item)
      }

      this.resetCombined()
    },
    onUnchoose () {
      this.chooseItemId = null
    },
    inCombinedSortTarget (index) {
      return this.combinedSortTargetIndexes.includes(index)
    },
    bulkAddCombinedSortTarget (index) {
      if (!this.combinedSortTargetIndexes.length) {
        this.combinedSortTargetIndexes.unshift(index)
      } else if (this.combinedSortTargetIndexes[0] - 1 >= index) {
        const targetIndexRange = _.range(
          index,
          this.combinedSortTargetIndexes[0]
        )
        this.combinedSortTargetIndexes = [
          ...targetIndexRange,
          ...this.combinedSortTargetIndexes
        ]
      } else if (
        this.combinedSortTargetIndexes[this.combinedSortTargetIndexes.length - 1] + 1 <= index
      ) {
        const targetIndexRange = _.range(
          this.combinedSortTargetIndexes[this.combinedSortTargetIndexes.length - 1] + 1,
          index + 1
        )
        this.combinedSortTargetIndexes = [
          ...this.combinedSortTargetIndexes,
          ...targetIndexRange
        ]
      }
    },
    onChooseItem (id) {
      return this.chooseItemId === id
    },
    resetCombined () {
      this.combinedSortTargetIndexes = []
    },
    movingItemCount () {
      if (!this.chooseItemId) return 0

      return this.combinedSortTargetIndexes.length
        ? this.combinedSortTargetIndexes.length
        : 1
    }
  }
}
</script>

<style>
.p-sortingItem__active {
  display: none;
}

.p-sortingItem__ghost.p-sortingItem__active {
  display: block;
}

.p-sortingItem__ghost {
  background-color: #3766fd;
  height: 3px;
  width: 100%;
}

.p-sortingItem__ghost > * {
  display: none;
}

.p-sortingItem__handle:hover {
  cursor: grab;
}

.p-sortingItem__handle:active {
  cursor: grabbing;
}
</style>
